import classes from "./PageSubheader.module.css";

const PageSubheader = (props) => (
    <p className={classes.PageSubheader} style={props.style}>
        {props.text}
    </p>
);

export default PageSubheader;
